import {observer} from "mobx-react";
import {useState} from "react";
import {DialogStore, fmsDocumentPrinterStore, fmsPackageDetailStore, fmsVlogPrinterStore} from "../../../store";
import {MultiPrinterSelectDialog, PrinterMultiSelectDialogStore} from "./MultiPrinterSelectDialog";
import {FmsPicklistDialog} from "./FmsPicklistDialog";
import {ShipmentProcessTypeDto} from "../../../api/fms";

const FmsPackageDetailActions = observer(function PackageDetailActions() {
    const [picklistDialogStore] = useState(new PrinterMultiSelectDialogStore())
    const [closePackageDialogStore] = useState(new PrinterMultiSelectDialogStore())
    const [picklistHistoryDialog] = useState(new DialogStore())

    const labelPrinterSelect =
        fmsPackageDetailStore.process !== ShipmentProcessTypeDto.INTERNAL &&
        fmsPackageDetailStore.process !== ShipmentProcessTypeDto.STORAGE_TRANSFER &&
        fmsPackageDetailStore.process !== ShipmentProcessTypeDto.STORAGE_TRANSFER_SCA &&
        fmsPackageDetailStore.process !== ShipmentProcessTypeDto.STORAGE_TRANSFER_SCA_FINISH

    return <>
        <MultiPrinterSelectDialog
            processSensitive={false}
            shipmentSensitive={false}
            labelPrinterSelect={labelPrinterSelect}
            store={picklistDialogStore}
            title="Pickliste drucken"
            okLabel="Pickliste drucken"
            action={
                async () => await fmsPackageDetailStore.printPicklist({
                    documentPrinter: picklistDialogStore.documentPrinter!,
                    labelPrinter: picklistDialogStore.vlogPrinter!,
                })
            }/>
        <MultiPrinterSelectDialog
            processSensitive={false}
            shipmentSensitive={false}
            labelPrinterSelect={labelPrinterSelect}
            store={closePackageDialogStore}
            title="Versandpaket schließen"
            okLabel="Abschließen"
            action={
                async () => await fmsPackageDetailStore.finish({
                    printerVlog: closePackageDialogStore.vlogPrinter!,
                    printerDocument: closePackageDialogStore.documentPrinter!,
                })
            }/>
        <FmsPicklistDialog store={picklistHistoryDialog}/>
        <div style={{
            display: 'flex'
        }}>
            <div>
                <button
                    className={'button is-primary is-outlined is-rounded'}
                    disabled={!fmsPackageDetailStore.picklists.length}
                    onClick={() => {
                        picklistHistoryDialog.dialogOpen = true
                    }}
                >
                    <span className="icon"><span className="material-symbols-outlined">print</span></span>
                    <span>Picklisten Historie</span>
                </button>
            </div>
            <div style={{paddingLeft: '1em'}}>
                <button
                    disabled={fmsPackageDetailStore.loading || !fmsPackageDetailStore.hasReadyItem || fmsPackageDetailStore.finished}
                    className={'button is-primary is-rounded'}
                    onClick={async () => {
                        await fmsVlogPrinterStore.load()
                        await fmsDocumentPrinterStore.load()
                        picklistDialogStore.dialogOpen = true
                    }}
                >
                    <span className="icon"><span className="material-symbols-outlined">print</span></span>
                    <span>Pickliste drucken</span>
                </button>
            </div>
            <div style={{paddingLeft: '1em'}}>
                <button
                    disabled={fmsPackageDetailStore.loading || fmsPackageDetailStore.finished || !fmsPackageDetailStore.readyToFinish}
                    className={'button is-primary is-rounded'}
                    onClick={async () => {
                        await fmsDocumentPrinterStore.load()
                        await fmsVlogPrinterStore.load()
                        closePackageDialogStore.process = fmsPackageDetailStore.process
                        closePackageDialogStore.dialogOpen = true
                    }}
                >
                    <span className="icon"><span className="material-symbols-outlined">input</span></span>
                    <span>Abschließen</span>
                </button>
            </div>
        </div>
    </>
})

export {
    FmsPackageDetailActions
}
